import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // In production you'd send this to a logging service
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/';
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={styles.wrapper}>
        <div style={styles.card}>
          <div style={styles.icon} aria-hidden="true">⚠️</div>
          <h1 style={styles.heading}>Something went wrong</h1>
          <p style={styles.body}>
            An unexpected error occurred. Your work is safe — this is a display
            issue only.
          </p>
          {process.env.NODE_ENV !== 'production' && this.state.error && (
            <pre style={styles.detail}>
              {this.state.error.toString()}
            </pre>
          )}
          <button style={styles.btn} onClick={this.handleReset}>
            Return to Home
          </button>
        </div>
      </div>
    );
  }
}

const styles = {
  wrapper: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f9fafb',
    padding: '2rem',
  },
  card: {
    background: 'white',
    borderRadius: '12px',
    padding: '3rem 2.5rem',
    maxWidth: '480px',
    width: '100%',
    textAlign: 'center',
    boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
    border: '1px solid #e5e7eb',
  },
  icon: {
    fontSize: '3rem',
    marginBottom: '1rem',
    display: 'block',
  },
  heading: {
    fontSize: '1.5rem',
    fontWeight: '700',
    color: '#111827',
    marginBottom: '0.75rem',
  },
  body: {
    fontSize: '1rem',
    color: '#6b7280',
    lineHeight: '1.65',
    marginBottom: '1.5rem',
  },
  detail: {
    background: '#f3f4f6',
    borderRadius: '6px',
    padding: '1rem',
    fontSize: '0.8125rem',
    color: '#ef4444',
    textAlign: 'left',
    overflowX: 'auto',
    marginBottom: '1.5rem',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  btn: {
    background: '#2563eb',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    padding: '0.75rem 2rem',
    fontSize: '1rem',
    fontWeight: '600',
    cursor: 'pointer',
  },
};

export default ErrorBoundary;
